<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center fx-gap-10">
  <input #inputText [formControl]="params.textControl" matInput class="mat-input-element ag-input-field-input"
    type="text"
    (keydown.tab)="onTextInputTab($event)"
    (focusin)="fullRowEdit && inputText.select()"/>
  @if (params.textControl.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" aria-hidden="true" class="tooltip-icon" [matTooltip]="textErrorTooltip"></mat-icon>
    </div>
  }
  <span>{{ '/' }}</span>
  <mat-select [formControl]="params.suffixControl"
    class="suffix-input mat-input-element ag-input-field-input"
    panelWidth="50px"
    hideSingleSelectionIndicator="true"
    [placeholder]="params.suffixControl.value">
    @for (suffixValue of suffixValues; track suffixValue) {
      <mat-option
      [value]="suffixValue">{{suffixValue}}</mat-option>
    }
  </mat-select>
  @if (params.suffixControl.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" aria-hidden="true" class="tooltip-icon" [matTooltip]="suffixErrorTooltip"></mat-icon>
    </div>
  }
  @if (!fullRowEdit) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-check" aria-hidden="true" (click)="stopEditing()"></mat-icon>
    </div>
  }
</div>
